module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toTopDiv),
      expression: "toTopDiv"
    }],
    attrs: {
      "id": "goTop"
    },
    on: {
      "click": _vm.toTop
    }
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kidClub_go_top"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/go_top_03.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f2d88cd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ToTop.vue
// module id = 60
// module chunks = 0